<template>
  <div>
    <div class="sub-header">
      <div class="header d-flex align-items-center justify-content-between">
        <div class="d-flex align-items-center">
          <i :class="['icon-question', 'align-self-baseline  header-icon']"></i>
          <h1 class="xxl">
            {{ resource['faq.Header'] }}
          </h1>
        </div>
        <div class="search-area">
          <img :src="require(`@/assets/hrVenue/search.svg`)" alt="Search Candidate" class="search-area__icon" />
          <b-form-input id="search-questions" name="search-questions" class="search-area__input" v-model="searchText"
            @input="searchQuestions" :placeholder="resource['candidates.searchPlaceholder']" />
        </div>
      </div>
    </div>
    <div class="page-view">
      <b-container class="p-0">
        <b-tabs pills card class="w-100 faq-tab" content-class="mt-3">
          <div v-if="searchText.length > 2 && filteredFaqList" class="card-block accordion h-100">
            <div v-if="filteredFaqList.length < 1" class="d-flex text-center justify-content-center h-100 flex-column">
              <img
                :src="require('@/assets/hrVenue/search-big.svg')"
                alt="icon search"
                height="45"
              >
              <p>{{ resource['label.NoResult'] }}</p>
            </div>
            <div v-else v-for="(faqGroup, index) in filteredFaqList" :key="index" class="mt-3">
              <div class="tab-title">
                <h3>{{ faqGroup.title }}</h3>
              </div>
              <b-card no-body class="mb-1" v-for="(faqItem, faqIndex) in faqGroup.questions" :key="faqIndex">
                <b-card-header header-tag="header" role="tab">
                  <b-button block variant="info" v-b-toggle="`accordion-${index + '-' + faqIndex}`">
                    <p class="text-left"> {{ faqItem.name }} </p>
                    <span class="when-closed"><i class="icon-down-arrow" aria-hidden="true"></i></span>
                  </b-button>
                </b-card-header>
                <b-collapse :id="`accordion-${index + '-' + faqIndex}`" accordion="my-accordion" role="tabpanel">
                  <b-card-body class="pt-3">
                    <b-card-text>
                      <div v-html="faqItem.answer"></div>
                    </b-card-text>
                  </b-card-body>
                </b-collapse>
              </b-card>
            </div>
          </div>
          <b-tab v-else v-for="(faqGroup, index) in faqList" :key="index" :title="faqGroup.title" lazy>
            <template #title>
              <img :src="require(`@/assets/hrVenue/${faqGroup.icon}`)" :alt="faqGroup.title" height="45" />
              <p>{{ faqGroup.title }}</p>
            </template>
            <div class="card-block accordion" role="tablist">
              <vue-content-loading v-if="loading" :height="200" :speed="1">
                <rect x="0" y="0" rx="4" ry="4" width="90" height="100%" />
                <rect x="105" y="0" rx="4" ry="4" width="90" height="100%" />
                <rect x="205" y="0" rx="4" ry="4" width="90" height="100%" />
                <rect x="305" y="0" rx="4" ry="4" width="90" height="100%" />
              </vue-content-loading>
              <div v-else>
                <div class="tab-title">
                  <h3>{{ faqGroup.title }}</h3>
                </div>
                <b-card no-body class="mb-1" v-for="(faqItem, faqIndex) in faqGroup.questions" :key="faqIndex">
                  <b-card-header header-tag="header" role="tab">
                    <b-button block variant="info" v-b-toggle="`accordion-${faqIndex}`">
                      <p class="text-left"> {{ faqItem.name }} </p>
                      <span class="when-closed"><i class="icon-down-arrow" aria-hidden="true"></i></span>
                    </b-button>
                  </b-card-header>
                  <b-collapse :id="`accordion-${faqIndex}`" accordion="my-accordion" role="tabpanel">
                    <b-card-body class="pt-3">
                      <b-card-text>
                        <div v-html="faqItem.answer"></div>
                      </b-card-text>
                    </b-card-body>
                  </b-collapse>
                </b-card>
              </div>
            </div>
          </b-tab>
        </b-tabs>
        <b-row class="mt-3">
          <div cols="12" class="contact-area">
            <h3>{{ resource['faq.contactTitle'] }}</h3>
            <div class="d-block d-md-inline-block contact-item">
              <i class="icon-contact align-middle mr-1" />
              <a href="tel:+37266-4-0033" class="mr-5 align-middle">+37266-4-0033</a>
            </div>
            <div class="d-block d-md-inline-block contact-item">
              <i class="icon-send-message align-middle mr-1" />
              <a href="mailto:support@interview.co" class="align-middle"
                target="_top">support@interview.co</a>
            </div>
          </div>
        </b-row>
      </b-container>
    </div>
  </div>
</template>

<script>
import { faqs } from '../../static/faqs';

export default {
  name: 'Faq',

  data() {
    return {
      faqList: [],
      loading: true,
      searchText: '',
      searchTextTimeout: null,
      filteredFaqList: [],
    };
  },

  created() {
    this.faqList = faqs;
    this.loading = false;
  },

  methods: {
    filterFaqList(query) {
      const filteredFaqList = [];

      // eslint-disable-next-line no-restricted-syntax
      for (const faqItem of this.faqList) {
        const filteredQuestions = [];

        // eslint-disable-next-line no-restricted-syntax
        for (const question of faqItem.questions) {
          if (
            (question.name.toLowerCase().includes(query)
              || faqItem.title.toLowerCase().includes(query))
            && !filteredQuestions.some((q) => q.name === question.name)
          ) {
            filteredQuestions.push(question);
          }
        }

        if (filteredQuestions.length > 0) {
          filteredFaqList.push({
            title: faqItem.title,
            questions: filteredQuestions,
          });
        }
      }

      this.filteredFaqList = filteredFaqList;
    },

    async searchQuestions() {
      clearTimeout(this.searchTextTimeout);
      this.searchTextTimeout = setTimeout(async () => {
        if (this.searchText === '') {
          this.loading = true;
          // search api
          this.filteredFaqList = [];
          this.loading = false;
        } else if (this.searchText.length > 2) {
          this.loading = true;
          // search api
          this.filterFaqList(this.searchText.toLowerCase().trim());
          this.loading = false;
        }
      }, 500);
    },
  },
};
</script>

<style lang="scss" scoped>
.faq-contact-wrapper {
  margin-top: 20px;
  margin-bottom: 40px;
}

.faq-contact-header {
  margin-bottom: 16px;
}

.faq-contact-mail-icon {
  background-color: #574560;
  padding: 5px;
  border-radius: 50%;
  padding-right: 7px;
  padding-left: 7px;
}

.faq-contact-phone-icon {
  padding-top: 0px;
  padding-bottom: 0px;
  font-size: 19px;
  padding-right: 8px;
  padding-left: 8px;
  background-color: #574560;
  border-radius: 50%;
}

.faq-contact-phone {
  margin-left: 10px;
  margin-right: 30px;
}

.faq-contact-mail {
  margin-left: 10px;
}

.faq-tab {
  ::v-deep {
    .card-header {
      background-color: transparent;
      border-bottom: 0;
      padding: 0;
    }

    .card-header-pills {
      margin: 0;
    }

    .tab-content {
      height: calc(100vh - 405px);
      overflow-y: auto;
      margin-bottom: 48px;
      background: #FFF;
    }

    .nav {
      gap: 8px;
      max-width: 100%;
    }

    .nav-item {
      flex-basis: calc((100% - 16px) / 3);

      a {
        border-radius: 4px;
        border: 1px solid #E4E4E4;
        padding: 12px 24px 12px 12px;
        width: 100%;
        color: #353535;
        font-size: 18px;
        font-weight: 700;
        line-height: 22px;
        display: flex;
        align-items: center;
        gap: 8px;
        background: #FFF;
      }

      .active {
        background: #FFF6E5;
        border: 1px solid #FF8D06;
      }
    }

    .card-body {
      padding: 0;
    }

    .card-block {
      padding: 16px 16px 0;
    }

    .tab-title {
      position: -webkit-sticky;
      position: sticky;
      top: 0;
      z-index: 9;
      background: #FFF;

      h3 {
        font-size: 18px;
        font-weight: 700;
        line-height: 22px;
        color: #353535;
      }
    }
  }
}

.contact-area {
  h3 {
    font-size: 18px;
    font-weight: 700;
    line-height: 22px;
    margin-bottom: 16px;
  }

  .contact-item {
    i {
      font-size: 1.5rem;
    }

    a {
      text-decoration: underline;
    }
  }
}

::v-deep {
  .accordion {
    .card {
      padding: 16px 0px;
      border: 0;
      border-bottom: 1px solid #E4E4E4;

      &:last-child {
        border-bottom: 0;
      }

      .btn {
        padding: 0 !important;
        display: flex;
        justify-content: space-between;

        p {
          font-size: 14px;
          font-weight: 500;
          color: #353535;
        }
      }

      .collapsed>.when-closed {
        transform: rotate(0);
        transition: transform 0.35s;

        i {
          margin: 0;
        }
      }

      :not(.collapsed)>.when-closed {
        transform: rotate(180deg);
        transition: transform 0.35s;

        i {
          margin: 0;
        }
      }
    }

    .card-text {
      color:  #858585;
      font-size: 14px;
      font-weight: 400;
      line-height: 20px;
    }
  }

}

.search-area {
  display: flex;
  align-self: center;
  position: relative;

  &__icon {
    position: absolute;
    width: 1.0625rem;
    height: 1.0625rem;
    right: 12px;
    top: 10px;
  }

  &__input {
    width: 350px;
    font-family: 'Roboto';
    font-size: 0.875rem;
    font-style: normal;
    font-weight: 400;
    line-height: 1.125rem
  }
}</style>
